/**
 * Cart upsell add-to-cart for "People often combine with".
 * Uses cart/add.js and CartLinesUpdateEvent so Horizon refreshes the cart drawer/page.
 */
import { CartLinesUpdateEvent } from '@shopify/events';

/** @param {Event} event */
async function onCombineAddClick(event) {
  const target = event.target instanceof Element ? event.target : null;
  const button = target?.closest('[data-combine-add]');
  if (!(button instanceof HTMLButtonElement)) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = button.dataset.variantId;
  if (!variantId || button.disabled) return;

  const originalText = button.textContent?.trim() || 'Add';
  button.disabled = true;
  button.textContent = 'Adding...';

  const deferredEventPromise = CartLinesUpdateEvent.createPromise();
  const lines = [
    {
      merchandiseId: String(variantId),
      quantity: 1,
    },
  ];

  document.dispatchEvent(
    new CartLinesUpdateEvent({
      action: 'add',
      context: 'cart',
      lines,
      promise: deferredEventPromise.promise,
    })
  );

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: 1,
          },
        ],
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.description || errorData.message || 'Unable to add product');
    }

    await response.json();

    const cartResponse = await fetch(`${root}cart.js`);
    const cart = await cartResponse.json();

    deferredEventPromise.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: {
        items: cart.items,
        source: 'people-often-combine',
        itemCount: 1,
      },
    });

    button.textContent = 'Added';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 900);
  } catch (error) {
    deferredEventPromise.reject(error);
    button.textContent = error instanceof Error ? error.message : 'Try again';
    setTimeout(() => {
      button.textContent = originalText;
      button.disabled = false;
    }, 1800);
  }
}

document.addEventListener('click', onCombineAddClick);
